/**
 * Measure window width
 * Fallback for iOS: returns 0 when window.outerWidth is being used
 * Fallback for Safari: measures media query window width through document.documentElement.clientWidth
 * 
 * @author Rianne Oosthoek
 */
window.getWindowWidth = function(){
    var $body = $('body');
    var $window = $(window);

    if( $body.hasClass('is-touch') || $body.hasClass('is-safari') ){
        return $window.width();
    }else if( $body.hasClass('is-desktop') ){
        return window.outerWidth;
    }   
};



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/utilities/window-width.js